export default "__VITE_ASSET__BcL0yl_e__"